export default __webpack_public_path__ + "static/media/loader.98678245.svg";